import React from 'react';
import BetNotificationToast, { BetNotification } from './BetNotification';
import './BetNotificationContainer.css';

interface BetNotificationContainerProps {
  notifications: BetNotification[];
  onDismiss: (id: string) => void;
}

const BetNotificationContainer: React.FC<BetNotificationContainerProps> = ({ 
  notifications, 
  onDismiss 
}) => {
  if (notifications.length === 0) return null;

  return (
    <div className="bet-notification-container">
      {notifications.map(notification => (
        <BetNotificationToast
          key={notification.id}
          notification={notification}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
};

export default BetNotificationContainer;

